module.exports = __webpack_public_path__ + "files/bbc4977d614bebae0c00dc05220f4f23.png";